import React, { Component } from 'react'
import { Modal, Button } from "antd";
import { ModalAction, OnModalAction } from "easyui-core";
import { ModalChildProps } from "./ModalChildProps";

export class ModalComponent extends Component<any, any> {

    onClose
    onDismiss

    footerActions: ModalAction[] = [ModalAction.SAVE, ModalAction.CANCEL]
    // onActionClose: (...args: any[]) => Promise<any> | void = () => { }
    // onActionDismiss: (...args: any[]) => Promise<any> | void = () => { }
    // onAction: (...args: any[]) => Promise<any> | void = () => { }
    modalTitle: string
    data: any
    C: any
    child: OnModalAction
    constructor(props) {
        super(props)
        this.state = {
            ModalText: 'Content of the modal',
            visible: true,
            loading: {},
        };
        this.onClose = this.props.onOk ? this.props.onOk : () => { }
        this.onDismiss = this.props.onDismiss ? this.props.onDismiss : () => { }
        if (this.props.modalActions) {
            this.footerActions = this.props.modalActions
        }
        debugger
        this.data = this.props.data
        this.C = this.props.component
        this.modalTitle = this.props.title
    }

    showModal = () => {
        this.setState({
            visible: true,
        });
    };
    handleOk = (action) => {
        let result = this.child.onModalClose(action)
        if (result instanceof Promise) {
            this.setState({ loading: { [action.key]: true } });
            result.then(data => {
                if (data == 'success') {
                    this.setState({ loading: { [action.key]: false }, visible: false, });
                    this.onClose()
                } else if (data == 'error') {
                    this.setState({ loading: { [action.key]: false }, visible: true, });
                }
            })
        } else {
            this.setState({ loading: { [action.key]: false }, visible: true, });
        }
    }
    handleCancel = (action) => {
        let result = this.child.onModalDismiss(action)
        if (result instanceof Promise) {
            this.setState({ loading: { [action.key]: true } });
            result.then(data => {
                this.onDismiss()
                this.setState({ loading: { [action.key]: false }, visible: false, });
            })
        } else {
            this.setState({ loading: { [action.key]: false }, visible: false, });
        }
    }

    handleAction = (action: ModalAction) => {
        if (action.isClose) {
            this.handleOk(action)
        } else if (action.isCancel) {
            this.handleCancel(action)
        } else {
            let result = (this.child.onModalAction as any)(action)
            if (result instanceof Promise) {
                this.setState({ loading: { [action.key]: true } });
                result.then(data => {
                    this.setState({ loading: { [action.key]: false }, visible: false, });
                })
            } else {
                this.setState({ loading: { [action.key]: false }, visible: false, });
            }
        }

    }

    render() {

        const {
            onCancel,
            onOk,
            close,
            zIndex,
            afterClose,
            visible,
            keyboard,
            centered,
            getContainer,
            maskStyle,
            okButtonProps,
            cancelButtonProps,
            iconType = 'question-circle',
        } = this.props;

        let footerItems: any[] = []
        if (this.props.modalActions) {
            footerItems = this.props.modalActions.map(action => (
                <Button key={action.key} type={action.isClose ? 'primary' : 'default'} loading={this.state.loading[action.key]} onClick={e => { this.handleAction(action) }}>
                    {action.name}
                </Button>
            ))
        } else {
            footerItems = this.footerActions.map(action => (
                <Button key={action.key} type={action.isClose ? 'primary' : 'default'} loading={this.state.loading[action.key]} onClick={e => { this.handleAction(action) }}>
                    {action.name}
                </Button>
            ))
        }

        const C: any = this.C
        let modalChildProps: ModalChildProps = {
            data: this.data,
            functions: {
                // onClose: this.onActionClose,
                // onDismiss: this.onActionDismiss,
                // onAction: this.onAction
            },
            triggerRef: this.bindRef
        }
        const child = <C {...modalChildProps} />
        return (
            <Modal
                title={this.modalTitle}
                visible={this.state.visible}
                onOk={this.handleOk}
                onCancel={this.handleCancel}
                afterClose={afterClose}
                footer={footerItems}
            >
                {child}
            </Modal>)
    }
    bindRef = ref => {
        debugger
        this.child = ref
    }
}
